export const testimonialsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 4,
        599: "auto",        
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution];

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
            spaceBetween: 30,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 12,
        cssMode: false,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}